module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mc-upload-wrap file-upload-warp"
  }, [_c('div', {
    directives: [{
      name: "fileupload",
      rawName: "v-fileupload",
      value: (_vm.fileUrl),
      expression: "fileUrl"
    }],
    staticClass: "upload-btn-wrap",
    on: {
      "upload-change": _vm.fileUploadSuccess
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "icon": "upload2",
      "type": "primary"
    }
  }, [((_vm.workMode === 'url-name' && _vm.fileName) || (_vm.workMode === 'url' && _vm.fileUrl)) ? [_vm._v("re-upload file")] : [_vm._v("upload file")]], 2)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.workMode === 'url-name' && _vm.fileName) || (_vm.workMode === 'url' && _vm.fileUrl)),
      expression: "(workMode === 'url-name' && fileName) || (workMode === 'url' && fileUrl)"
    }],
    staticClass: "file-info hf"
  }, [_c('div', {
    staticClass: "label ftp"
  }, [_vm._v("upload ready")]), _vm._v(" "), _c('i', {
    staticClass: "ftp el-icon-document"
  }), _vm._v(" "), (_vm.workMode === 'url-name') ? _c('div', {
    staticClass: "file-name ftp",
    style: ({
      width: _vm.width - 75 + 'px'
    })
  }, [_vm._v(_vm._s(_vm.fileName))]) : _vm._e(), _vm._v(" "), (_vm.workMode === 'url') ? _c('div', {
    staticClass: "file-name ftp",
    style: ({
      width: _vm.width - 75 + 'px'
    })
  }, [_vm._v(_vm._s(_vm.fileUrl))]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-4e6bc863","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/libcomponents/file-upload/file-upload.vue
// module id = 765
// module chunks = 1